import React from 'react';
import styles from '../static/css/footer.module.css';

function Footer() {
    return (
        <div className={styles.container}>
            <div>
                <p>
                    <a href="https://www.sebi.gov.in/website-policy.html#terms">Terms & Conditions</a>
                    <span>  |  </span>
                    <a href="https://www.sebi.gov.in/website-policy.html#privacypolicy">Privacy Policy</a>
                </p>
            </div>
            <div>
                <p>© SEBI All Rights Reserved - Website Owned and Managed by SEBI</p>
            </div>
        </div>
    )
}

export default Footer